module.exports = __webpack_public_path__ + "static/media/living_needs_icon-color.c6d15e87.svg";